import { seoContent } from '@/mocks/seoContent';

export default function AboutSection() {
  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="section-container">
        <div className="flex flex-col lg:flex-row gap-10 lg:gap-16 items-center">
          <div className="lg:w-[55%]">
            <span className="inline-block px-4 py-1.5 bg-secondary-100 text-secondary-800 text-xs font-semibold rounded-full tracking-wide uppercase mb-5">
              {seoContent.aboutSubtitle}
            </span>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-heading font-bold text-foreground-950 leading-tight">
              {seoContent.aboutTitle}
            </h2>
            <p className="mt-6 text-foreground-600 text-sm md:text-base leading-relaxed max-w-lg">
              {seoContent.aboutDescription}
            </p>
            <div className="mt-8">
              <a
                href="https://kaspreadsheet.com/"
                target="_blank"
                rel="noopener nofollow"
                className="btn-primary text-sm inline-flex items-center gap-2"
              >
                <i className="ri-external-link-line"></i>
                Visit Main Platform
              </a>
            </div>
          </div>

          <div className="lg:w-[45%]">
            <div className="bg-accent-600 rounded-2xl p-6 md:p-8 relative overflow-hidden">
              <div className="absolute top-4 left-4 text-accent-400/40 text-xs font-medium">
                User Review
              </div>
              <div className="absolute top-4 right-4 flex gap-1.5">
                <span className="w-1.5 h-1.5 rounded-full bg-accent-300/50"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-accent-300/50"></span>
                <span className="w-1.5 h-1.5 rounded-full bg-accent-300/50"></span>
              </div>
              <div className="mt-6">
                <i className="ri-double-quotes-l text-3xl text-accent-300/50"></i>
                <p className="mt-3 text-background-50 text-base md:text-lg leading-relaxed font-light italic">
                  {seoContent.aboutQuote}
                </p>
              </div>
              <div className="mt-6 flex items-center gap-3">
                <div className="w-10 h-10 rounded-full bg-accent-400 flex items-center justify-center text-background-50 font-semibold text-sm">
                  AM
                </div>
                <div>
                  <p className="text-background-50 text-sm font-semibold">
                    {seoContent.aboutQuoteName}
                  </p>
                  <p className="text-accent-200 text-xs">
                    {seoContent.aboutQuoteRole}
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}